import shop from '../../api/shop'
import _ from "lodash";
import moment from "moment";

const state = () => ({
  all: [],
  selected: null, // Id
  selectedRestaurant: null, // Object
  restaurant: null,
  menus: [],
  products: [],
});

const getters = {
  currentRestaurantPos: state => {
    if (state.all && state.selected) {
      let found = state.all.find(item => item.pos.Id === state.selected)
      if (found) return found
    }
    return null
  },
  currentMenu: state => {
    if (state.selectedRestaurant) {
      let data = state.selectedRestaurant;
      let menu = _.sortBy(data.item_types,['sort','name']);
      return menu.filter(item_type => item_type.active === 1)
    }
  },

  currentProducts: ({selectedRestaurant,currentMenu}) => {
    if (selectedRestaurant) {

      // Danh mục menu , sắp xếp theo tên, và phải active
      let menus = _.sortBy(selectedRestaurant.item_types,['sort','name'])
                        .filter(item_type => item_type.active === 1);
      // lọc món , món phải có active và có trong danh mục active
      let items = selectedRestaurant.items.filter(product => {
                        let productActive = true;
                        let menu = _.find(menus, {'text_id': product.type_id, 'active': 1});
                        if ('DEACTIVE' === product.status.toUpperCase()) productActive = false;
                        if (typeof menu === 'undefined') productActive = false;
                        return productActive;});

      let  groupMenu = function (value) {
        if (!value) return [];
        let result = _.chain(value)
          .groupBy("type_id")
          .value();
        return result;
      };

      items = groupMenu(items)

      let {list_normal_combo: combos_1 , list_special_combo: combos_2 } = selectedRestaurant;

      let filterComboActive = (combos, products) => {
        if (!combos) return [];
        return combos.filter((combo, index, arr) => {

          let start_date = moment(combo.start_date).tz("Asia/Ho_Chi_Minh").valueOf();
          let start_time = combo.start_hour;
          let end_date = moment(combo.end_date).tz("Asia/Ho_Chi_Minh").valueOf();
          let end_time = combo.end_hour;
          let now_date = moment().tz("Asia/Ho_Chi_Minh").valueOf();
          let now_time = moment().tz("Asia/Ho_Chi_Minh").format('HH');

          if (combo.start_date) {
            if (now_date < start_date) return false;
          }
          if (combo.end_date) {
            if (now_date > end_date) return false;
          }
          if (combo.start_hour) {
            if (now_time < start_time) return false;
          }
          if (combo.end_hour) {
            if (now_time > end_time) return false;
          }

          if (!Array.isArray(combo.combo_details) || !combo.combo_details.length || !combo.active) return false;
          combos[index].ta_price = 0;
          combos[index].combo_details = this._.sortBy(combos[index].combo_details, ['order']);
          //Lay chi tiet san pham cho combo (store_item_id)
          for (let i = 0; i < combo.combo_details.length; i++) {
            let listId = combo.combo_details[i].item_id_list || combo.combo_details[i].item_id;
            if (!listId) return false;
            let listIdArray = listId.split(",");
            let listDetail = _.filter(products, product => {
              let isDetail = listIdArray.indexOf(product.Item_Id) >= 0;
              /*if(isDetail && product.Item_Image_Path && !combos[index].image_url){
                  combos[index].image_url = product.Item_Image_Path;
              }*/
              return isDetail;
            });
            combos[index].combo_details[i].details = listDetail;
            combos[index].combo_details[i].selected = listIdArray[0];
            combos[index].ta_price = combos[index].ta_price + combo.combo_details[i].ta_price;
          }
          if (!combos[index].ta_price) return false;
          return true;
        })
      };

      //Check nomal combo
      if (combos_1 && Array.isArray(combos_1)) {
        combos_1 = filterComboActive(combos_1, items)
        if (combos_1.length) {
          items.list_normal_combo = combos_1;
          state.menus.push({
            "active": 1,
            "name": "COMBO THƯỜNG",
            "text_id": "list_normal_combo",
          });
        }
      }

      //Check special combo
      if (combos_2 && Array.isArray(combos_2)) {
        combos_2 = filterComboActive(combos_2, items)
        if (combos_2.length) {
          items.list_special_combo = combos_2;
          state.menus.push({
            "active": 1,
            "name": "COMBO ĐẶC BIỆT",
            "text_id": "list_special_combo",
          });
        }
      }

      state .products = items
      return items
    }
  },
  timeDelivery: ({selectedRestaurant}) => {
    if (selectedRestaurant) return selectedRestaurant.time_delivery
  }
};

const actions = {
  getAllRestaurants ({ commit }) {
    shop.getRestaurants(restaurants => {
      commit('setRestaurants', restaurants)
    })
  },

  setSelected ({state, commit} , id) {
    if (id) {
      let found = state.all.find(item => item.pos.Id === id)
      if (found) {
        commit('setSelected',id)
        commit('setSelectedRestaurant',found)
        commit('setRestaurant',found)
      }
    } else {
      commit('setSelected',null)
      commit('setSelectedRestaurant',null)
      commit('setRestaurant',null)
    }
  },

};

const mutations = {
  setRestaurants: (state, restaurants) => state.all = restaurants,
  setSelected: (state, id) => state.selected = id,
  setSelectedRestaurant: (state, data) => (state.selectedRestaurant = data),
  setRestaurant: (state, data) => (state.restaurant = data),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/restaurants.js